/**
 * @prettier
 * @flow
 */
import { FormHelperText } from '@material-ui/core';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import * as React from 'react';
import { useFormContext } from 'react-hook-form';
import { FormAddressCityField } from 'src/components/form/shipping-details/FormAddressCityField';
import { FormAddressLine1Field } from 'src/components/form/shipping-details/FormAddressLine1Field';
import { FormAddressLine2Field } from 'src/components/form/shipping-details/FormAddressLine2Field';
import { FormAddressStateField } from 'src/components/form/shipping-details/FormAddressStateField';
import { FormAddressZipCodeField } from 'src/components/form/shipping-details/FormAddressZipCodeField';
import { removeNulls } from 'src/utils/removeNulls';
import { translate } from 'src/utils/translate/translate';

export function FormShippingDetailsField({ name, required }: Props) {
    const { errors } = useFormContext();

    return (
        <Grid container spacing={0}>
            <Grid item xs={12}>
                <Typography variant='overline' color='textSecondary'>
                    {translate('Shipping Details')}
                </Typography>
                <FormAddressLine1Field name={name} rules={{ required }} />
            </Grid>
            <Grid item xs={12}>
                <FormAddressLine2Field name={name} />
            </Grid>
            <Grid item xs={6}>
                <FormAddressZipCodeField name={name} rules={{ required }} />
            </Grid>
            <Grid item xs={6}>
                <FormAddressCityField name={name} rules={{ required }} />
            </Grid>
            <Grid item xs={12}>
                <FormAddressStateField name={name} rules={{ required }} />
            </Grid>
            <FormHelperText error>
                {removeNulls([
                    errors[name]?.['addressLine1']?.message,
                    errors[name]?.['addressLine2']?.message,
                    errors[name]?.['zipCode']?.message,
                    errors[name]?.['city']?.message,
                    errors[name]?.['state']?.message,
                ]).join(', ')}
            </FormHelperText>
        </Grid>
    );
}

type Props = {|
    name: string,
    required?: boolean,
|};
